// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 14-May-2019 10:00:00 AM
// File Created Date      : 14-May-2019 10:00:00 AM
import { http } from '@/shared/https';
import { Notification, INotification} from '@/entities'
import Vue from 'vue'
export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        card: {
            type: 'Grid'
        },
        contextMenu: false,
        parentComponent: true,
        hideButtons: ['Edit'],
        redirect: {
            menuId:102,
            action: '/Admin/Program/UsefulDocument/UsefulDocumentForm'
        },
        actions: {
            listAction: "/api/UsefulDocument/List/",
            deleteAction: "/api/UsefulDocument/",
            updateAction: "/api/UsefulDocument",
            createAction: "/api/UsefulDocument"
        },
        fields: {
            UsefulDocumentId: {
                primaryKey: true
            },
            ProgramId: {
                type: "ComboBox",
                autocomplete: true,
                required: true,
                title: "Program",
                redirect: {
                    menuId:102,
                    action: '/Admin/Program/UsefulDocument/UsefulDocumentForm'
                },
            },
            Initiative: {
                title: "Initiative",
                required: true,
                type: "TextInput",
            },
            DocId: {
                type: "ComboBox",
                autocomplete: true,
                required: true,
                title: "Document type",
            },
            FileName: {
                type: "TextInput",
                required: true,
                title: "File name",
            },
            Link: {
                type: "TextInput",
                title: "Link",
                required: true,
                sortable: true,
                editReadonly: true,
                create: true
            },
            Language:{
                type: "ComboBox",
                autocomplete: true,
                required: true,
                title: "Language",
            }
        },
        importOption: {
            enabled: true,
            actionName:"importData"
        }
    },

    //#. Used to access data from the state tree of the store
    getters: {
    },

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) {
        },

        //#. fn_formCancel function
        formCancel(state, payload) {
        },

        //#. fn_recordCreated function
        recordCreated(state, payload) {
        },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) {
        },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) {
        },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) {
        },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) {},

        importData(state, payload) {}
    },
    
        //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
        actions: {
            //#. formCreated event will be fired
            formCreated: ({ commit, rootState }, payload) => {
                commit('formCreated', { rootState, payload });
            },
    
            //#. formCancel event will be fired
            formCancel: ({ commit, rootState }, payload) => {
                commit('formCancel', { rootState, payload });
            },
    
            //#. recordAdded event will be fired
            recordCreated: ({ commit, rootState }, payload) => {
                commit('recordCreated', { rootState, payload });
            },
    
            //#. recordUpdated event will be fired
            recordUpdated: ({ commit, rootState }, payload) => {
                commit('recordUpdated', { rootState, payload });
            },
    
            //#. recordUpdated event will be fired
            recordDeleted: ({ commit, rootState }, payload) => {
                commit('recordDeleted', { rootState, payload });
            },
            //#. loadingRecords event will be fired
            loadingRecords: ({ commit, rootState }, payload) => {
                commit('loadingRecords', { rootState, payload });
            },
    
            //#. recordsLoaded event will be fired
            recordsLoaded: ({ commit, rootState }, payload) => {
                commit('recordsLoaded', { rootState, payload });
            },

            importData: ({ dispatch , commit, rootState }, payload) => {
                payload.self.$store.commit('application/updateOverlay', true, { root: true });
                return http.post(`api/UsefulDocument/Import/0`,payload.formData)
                .then((resp: any) => {
                    if(resp.data.Result=="OK")
                    {
                    payload.self.$store.dispatch('load',payload.self.$store.state['usefulDocumentIndex'])
                    payload.self.$store.commit('application/updateOverlay', false);
                    payload.self.$store.commit('application/setNotification', new Notification({ snack: true, isHtml: false, text: 'Imported Sucessfully.', color: 'success' } as INotification))
                    }
                    else
                    {
                        payload.self.$store.commit('application/updateOverlay', false);
                        payload.self.$store.commit('application/setNotification', new Notification({ snack: true, isHtml: false, text: 'Import Failed.', color: 'error' } as INotification))
                    }
                }).catch(err=>{
                    payload.self.$store.commit('application/updateOverlay', false);
                    payload.self.$store.commit('application/setNotification', new Notification({ snack: true, isHtml: false, text: 'Import Failed.', color: 'error' } as INotification))
                })
            },
    }
}